//axios api
import api from "@/lib/Api";

export const createQuestionnarieSettings = async (data) => {
  try {
    const queryRoute = `/questionnarie/questionnarieSettings`;
    const reqBody = { data };
    const result = await api.axios.post(queryRoute, reqBody);

    return result.data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const updateQuestionnarieSettings = async (data) => {
  try {
    const queryRoute = `/questionnarie/questionnarieSetting`;
    const reqBody = { data };
    const result = await api.axios.put(queryRoute, reqBody);

    return result.data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getQuestionnarieSetting = async (data) => {
  try {
    const queryRoute = `/questionnarie/questionnarieSetting?questId=${data}`;
    const result = await api.axios.get(queryRoute);

    return result.data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getQuestionnarieSettings = async () => {
  try {
    const queryRoute = `/questionnarie/questionnarieSettings`;
    const result = await api.axios.get(queryRoute);

    return result.data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getReplyQuestionnaire = async (questId) => {
  try {
    const queryRoute = `/questionnarie/replyQuestionnaire?questId=${questId}`;
    const result = await api.axios.get(queryRoute);
    return result.data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getReplyQuestionnaireExcel = async (questId) => {
  try {
    const queryRoute = `/questionnarie/replyQuestionnaireExcel?questId=${questId}`;

    const result = await api.axios.get(queryRoute, {
      responseType: "blob",
    });

    return result.data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const downloadPhotos = async (questId) => {
  try {
    const queryRoute = `/questionnarie/photos?questId=${questId}`;

    const result = await api.axios.get(queryRoute, {
      responseType: "blob",
    });

    return result.data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getReplyQuestionnaireByUser = async (questId, promoterId) => {
  try {
    const queryRoute = `/questionnarie/replyQuestionnaireByUser?questId=${questId}&promoterId=${promoterId}`;
    const result = await api.axios.get(queryRoute);

    return result.data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const questionnaireSelection = async () => {
  try {
    const queryRoute = `/questionnarie/questionnaireSelection`;
    const result = await api.axios.get(queryRoute);

    return result.data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
